var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { Duration } from 'luxon';
import { useEffect, useEffectEvent, useRef, useState } from 'react';
const calculateDurationFromNow = (to) => Duration.fromMillis(Math.max(0, to.getTime() - Date.now()));
const ZERO_DURATION = Duration.fromMillis(0);
export const useCountDown = (countDownTo, onCountDown) => {
    _react_refresh_temp_1();
    const [timeRemaining, setTimeRemaining] = useState(() => calculateDurationFromNow(countDownTo));
    const firedRef = useRef(false);
    const onTick = useEffectEvent(() => {
        const newDuration = calculateDurationFromNow(countDownTo);
        if (newDuration.toMillis() > 0) {
            setTimeRemaining(newDuration);
            return;
        }
        setTimeRemaining(ZERO_DURATION);
        if (!firedRef.current) {
            firedRef.current = true;
            onCountDown?.();
        }
    });
    useEffect(() => {
        const interval = setInterval(() => onTick(), 500);
        return () => clearInterval(interval);
    }, []);
    return timeRemaining;
};
_react_refresh_temp_1(useCountDown, "yK1aDVoSaumwbipJCMCK65kkB60=", false, () => [useEffectEvent]);
